import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { NewsDefaultSettings } from 'src/lib/fliko/models/estate/estate-settings.data';
import { NewsData } from 'src/lib/fliko/models/news/news.data';
import { Nullish } from 'src/lib/fliko/types/typeish.type';
import { UpdateIdOnly } from 'src/lib/fliko/types/update.type';
import { DatabaseService } from 'src/app/shared/services/database.service';

@Injectable({ providedIn: 'root' })
export class NewsService {
  constructor(private dbSrv: DatabaseService) {}

  /**
   * @path /news/$estateId/
   * @key id
   */
  private get news() {
    return this.dbSrv.estateFactory.getCollection<NewsData>('news/$eId');
  }

  public getNewsList$(): Observable<NewsData[]> {
    return this.news.getList();
  }

  public getNewsOnce(): Promise<NewsData[]> {
    return this.news.onceList();
  }

  public getNews$(id: string): Observable<NewsData | Nullish> {
    return this.news.getElement(id);
  }

  public setNews(news: NewsData): Promise<void> {
    return this.news.setElement(news.id, news);
  }

  public updateNews(news: UpdateIdOnly<NewsData>): Promise<void> {
    return this.news.updateElement(news.id, news);
  }

  public removeNews(news: NewsData): Promise<void> {
    return this.news.removeElement(news.id);
  }

  /**
   * @path /estateSettings/$estateId/newsDefaults
   */
  private get newsDefaults() {
    return this.dbSrv.estateFactory.getObject<NewsDefaultSettings>('estateSettings/$eId/newsDefaults');
  }

  public updateNewsDefaults(settings: NewsDefaultSettings): Promise<void> {
    return this.newsDefaults.update(settings);
  }

  public getNewsDefaults$(): Observable<NewsDefaultSettings | Nullish> {
    return this.newsDefaults.get();
  }
}
